import { render, staticRenderFns } from "./policy-status.vue?vue&type=template&id=311099da&scoped=true"
import script from "./policy-status.vue?vue&type=script&lang=js"
export * from "./policy-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311099da",
  null
  
)

export default component.exports